import * as React from "react";
import {
	IconButton,
	Typography,
	Box,
	Tooltip,
	Avatar,
	Menu,
	MenuItem,
	Link,
	ListItemIcon,
	Divider,
	Dialog,
	DialogTitle,
	DialogContent,
	Button,
	CircularProgress,
} from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import Settings from "@mui/icons-material/Settings";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import Logout from "@mui/icons-material/Logout";
import EditIcon from "@mui/icons-material/Edit";

import { getUserData } from "@/utils/userData";
import { checkIsNotLogged } from "@/utils/authCheck";
import { fetchWrapper } from "@/helpers/fetch-wrapper";
import { userService } from "../../../services/user.service";

const Profile = () => {
     checkIsNotLogged("/");
     const { userData } = getUserData();

	const [anchorEl, setAnchorEl] = React.useState(null);
	const open = Boolean(anchorEl);
	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};
	const handleClose = () => {
		setAnchorEl(null);
	};

	const [avatarDialogOpen, setAvatarDialogOpen] = React.useState(false);
	const [uploadingAvatar, setUploadingAvatar] = React.useState(false);
	const avatarInputRef = React.useRef(null);

	const handleAvatarFileChange = async (e) => {
		const file = e.target.files?.[0];
		e.target.value = "";
		if (!file) return;

		setUploadingAvatar(true);
		try {
			const formData = new FormData();
			formData.append("file", file);
			await fetchWrapper.post("/api/users/mobile/avatar-upload", formData);
			window.location.reload();
		} catch (error) {
			console.error("Eroare la incarcarea avatarului:", error);
			setUploadingAvatar(false);
		}
	};

     const handleLogout = () => {
          userService.logout();
     };
	return (
		<>
			<Tooltip title='Setarile contului'>
				<IconButton
					onClick={handleClick}
					size='small'
					sx={{ p: 0 }}
					aria-controls={open ? "account-menu" : undefined}
					aria-haspopup='true'
					aria-expanded={open ? "true" : undefined}
					className='ml-2'
				>
					<Avatar
						src={userData?.avatar}
						alt={userData?.firstName}
						sx={{ width: 40, height: 40 }}
					/>
				</IconButton>
			</Tooltip>

			<Menu
				anchorEl={anchorEl}
				id='account-menu'
				open={open}
				onClose={handleClose}
				onClick={handleClose}
				PaperProps={{
					elevation: 0,
					sx: {
						borderRadius: "10px",
						boxShadow:
							"0px 10px 35px rgba(50, 110, 189, 0.2)",
						overflow: "visible",
						filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
						mt: 1.5,
						"& .MuiAvatar-root": {
							width: 32,
							height: 32,
							ml: -0.5,
							mr: 1,
						},
						"&:before": {
							content: '""',
							display: "block",
							position: "absolute",
							top: 0,
							right: 14,
							width: 10,
							height: 10,
							bgcolor: "background.paper",
							transform: "translateY(-50%) rotate(45deg)",
							zIndex: 0,
						},
					},
				}}
				transformOrigin={{ horizontal: "right", vertical: "top" }}
				anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
				className='for-dark-top-navList'
			>
                    <Link href={userData?.admin == 0 ? '/':'/' }> 
                         <MenuItem>
                              
                                   <Avatar src={userData?.avatar} className='mr-1' />
                                   <Box>
                                        <Typography
                                             sx={{ fontSize: "11px", color: userData?.colaborator ? "#7c3aed" : userData?.admin < 1 ? "grey" : "red" }}
                                        >
                                             {userData?.colaborator ? "Colaborator" : userData?.admin == 0 ? "Client" : userData?.admin == 1 ? "Angajat":"Administrator" }
                                        </Typography>
                                        <Typography
                                             sx={{
                                                  fontSize: "13px",
                                                  color: "#260944",
                                                  fontWeight: "500",
                                             }}
                                        >
                                             {userData?.firstName} {userData?.lastName} 
                                        </Typography>
                                   </Box>
                         
                         </MenuItem>
                    </Link>

				<Divider />

				<MenuItem onClick={() => setAvatarDialogOpen(true)}>
					<ListItemIcon sx={{ mr: "-8px", mt: "-3px" }}>
						<EditIcon fontSize='small' />
					</ListItemIcon>
					Editeaza profil
				</MenuItem>

				<MenuItem>
					<ListItemIcon sx={{ mr: "-8px", mt: "-3px" }}>
                              <i class="ri-notification-3-line"></i>
					</ListItemIcon>
					<Link
						href='/notificari'
						fontSize='13px'
						color='inherit'
						underline='none'

					>
						Notificari
					</Link>
				</MenuItem>


				<Divider />

				<MenuItem>
					<ListItemIcon sx={{ mr: "-8px", mt: "-3px" }}>
						<Logout fontSize='small' />
					</ListItemIcon>

					<Link
						href='#'
						fontSize='13px'
						color='inherit'
						underline='none'
                              onClick={() => handleLogout()}
					>
						Deconectare
					</Link>
				</MenuItem>
			</Menu>

			<Dialog open={avatarDialogOpen} onClose={() => !uploadingAvatar && setAvatarDialogOpen(false)}>
				<DialogTitle>Editeaza profil</DialogTitle>
				<DialogContent>
					<Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 2, py: 2, minWidth: 260 }}>
						<Avatar src={userData?.avatar} sx={{ width: 96, height: 96 }} />

						<input
							type='file'
							accept='image/*'
							ref={avatarInputRef}
							style={{ display: "none" }}
							onChange={handleAvatarFileChange}
						/>

						<Button
							variant='contained'
							disabled={uploadingAvatar}
							onClick={() => avatarInputRef.current?.click()}
							startIcon={uploadingAvatar ? <CircularProgress size={16} /> : <EditIcon />}
						>
							{uploadingAvatar ? "Se incarca..." : "Schimba avatarul"}
						</Button>
					</Box>
				</DialogContent>
			</Dialog>
		</>
	);
};

export default Profile;
